module.exports = __webpack_public_path__ + "static/other-d3ce9702a8075a3a1c43eb389d656a87.svg";